// @mui
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Done from '@mui/icons-material/Done';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { TableSortTypes } from 'constants/settings.constants';

interface Props {
	title: string;
	text?: string;
}

export function Flag(props: Props) {
	return (
		<Box
			sx={{
				width: '30px!important',
				height: '30px',
				borderRadius: '50%',
				backgroundSize: 'cover!important',
			}}
			className={`fi fi-${props.title}`}
		></Box>
	);
}

export function SuccessIconMessage() {
	const theme = useTheme();

	return (
		<Box sx={{ height: '148px' }}>
			<Box
				sx={{
					width: '116px',
					margin: 'auto!important',
					height: '116px',
					backgroundColor: theme.palette.root.brandSecondary,
					borderRadius: '100%',
					textAlign: 'center',
					position: 'relative',
					'&:before': {
						width: '148px',
						height: '148px',
						backgroundColor: theme.palette.root.brandSecondary_012,
						borderRadius: '100%',
						textAlign: 'center',
						position: 'absolute',
						content: '" "',
						left: '-16px',
						top: '-16px',
					},
				}}
			>
				<Done sx={{ color: '#fff', height: '116px', width: '48px' }} />
			</Box>
		</Box>
	);
}

export function SortingIcon({ sortType, handleSort }) {
	return (
		<>
			{sortType === TableSortTypes.ASC ? (
				<ArrowDropDownIcon sx={{ cursor: 'pointer' }} onClick={() => handleSort(TableSortTypes.DESC)} />
			) : (
				<ArrowDropUpIcon sx={{ cursor: 'pointer' }} onClick={() => handleSort(TableSortTypes.ASC)} />
			)}
		</>
	);
}

export function CircleIcon({ icon, color }) {
	const theme = useTheme();

	return (
		<Box
			sx={{
				width: '16px',
				height: '16px',
				borderRadius: '50%',
				position: 'relative',
				background: color,
			}}
		>
			{icon}
		</Box>
	);
}
